import React from "react";
import { Form, Input } from "antd";
const FormItem = Form.Item;

const { TextArea } = Input;

const TextAreaInput = ({
  name,
  label,
  placeholder = "",
  value,
  onChange,
  disabled = false,
  required = false,
  rows = 4,
  errors,
  onBlur,
  getFieldDecorator
}) => (
  <FormItem
    label={label}
    validateStatus={errors[name] ? "error" : null}
    help={errors[name] || null}
    required={required}
  >
    <TextArea
      rows={rows}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      onBlur={onBlur}
    />
  </FormItem>
);

export default TextAreaInput;



// WEBPACK FOOTER //
// ./src/Modules/FormFields/TextArea.js